import React, { useRef, useEffect, useState } from 'react';
import './SendLoanForm.scss';

import { Icon } from '../../atoms/Icon/Icon';
import { SendLoanFormSubmitted } from '../SendLoanFormSubmitted/SendLoanFormSubmitted';
import { InputAutocompleteAddress, TextInput } from '../../atoms/TextInput/TextInput';
import { formatPhoneNumber } from '../PreApprovalForm/PreApprovalForm';

export const SendLoanForm = (props) => {
  const { isSelected, setBottomValue } = props;

  return (
    <div {...{ isSelected, setBottomValue }} className='step-section form'>
      <SendLoanFormInner />
    </div>
  );
}

export const sendLeadData = async (data) => {
  try {
    let response;
    response = await fetch(`${process.env.REACT_APP_BE_URL}/lead`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...data,
      urlParams: window.location.search
    })
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const responseData = await response.json();

    return responseData;
  } catch (error) {
    console.error('Error:', error);
  }
}

export const SendLoanFormInner = (props) => {
  const [formSubmitted, setFormSubmitted] = useState(false)

  const onSubmission = async (formData) => {
    await new Promise(res => setTimeout(res, 2000))
    const responseData = await sendLeadData({...formData, ...props.data})
    setFormSubmitted(true)
    try {
      const heap = window.heap
      if (heap && heap.identify && heap.addUserProperties) {
        if (responseData?._id) {
          heap.identify(responseData._id);
          heap.addUserProperties({ email: responseData.email });
        }
      }
    } catch (e) {

    }
  }

  return (
    <>
      {
        !formSubmitted
          ?
          <SendLoanFormContent {...props} onSubmission={onSubmission} />
          :
          <SendLoanFormSubmitted />
      }
    </>
  )
}

const StepSectionWrapper = (props) => {
  const { isSelected, setBottomValue, children } = props;

  const stepRef = useRef()

  useEffect(() => {
    if (stepRef.current && isSelected) {
      setBottomValue(stepRef.current.offsetTop)
    }
  }, [isSelected, stepRef.current])

  return (
    <div className='step-section' ref={stepRef}>
      {children}
    </div>
  );
}



export const SendLoanFormContent = (props) => {
  const { onSubmission, title } = props

  const [name, setName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [investmentAddress, setInvestmentAddress] = useState('')
  const [comments, setComments] = useState('')
  const [errors, setErrors] = useState({})
  const [touched, setTouched] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const validateInput = (label, value) => {
    switch (label) {
      case 'Name':
        return value.trim() === '' ? 'This field is required' : null;
      case 'Phone number':
        if (value.trim() === '') return 'This field is required';
        const digits = value.replace(/\D/g, '');
        if (digits.length < 10) return 'Phone number must have 10 digits';
        return null;
      case 'Email address':
        const emailRegex = /\S+@\S+\.\S+/;
        return !emailRegex.test(value) ? 'Invalid email address' : null;
      case "Investment Address":
        return value.trim() === "" ? "This field is required" : null;
      default:
        return null;
    }
  }

  const checkErrors = () => {
    const newErrors = {
      name: validateInput('Name', name),
      phoneNumber: validateInput('Phone number', phoneNumber),
      email: validateInput('Email address', email),
      investmentAddress: validateInput('Investment Address', investmentAddress),
    };
    setErrors(newErrors);
    return newErrors;
  }

  const handleSubmission = async () => {
    setTouched(true);
    const errors = checkErrors();
    const hasErrors = Object.values(errors).some(error => error !== null);

    if (!hasErrors) {
      setIsLoading(true)
      await onSubmission({ name, phoneNumber, email, investmentAddress, comments });
      setIsLoading(false)
    }
  }

  const handleChange = (setter, label) => (e) => {
    if (e && e.target) {
      setter(e?.target.value);
    } else {
      setter(e)
    }

    if (touched) {
      setErrors({
        ...errors,
        [label]: validateInput(label, e.target.value),
      });
    }
  };

  return (
    <div className='send-loan-form'>
      <div className='icon-container'>
        <Icon svgFilePath={"./assets/icons/icon-coins-blue.svg"} />
      </div>
      <div className='info'>
        <h1 className='title'>
          {title ?? "Where can we send loan options?"}
        </h1>
        <h3 className='description'>
          Enter your contact information below and one of our loan officers will reach out with custom loan options
        </h3>

        <input
          placeholder='Name'
          type='text'
          value={name}
          onChange={handleChange(setName, 'name')}
        />
        <p className='error'>{errors.name}</p>

        <input
          placeholder='Phone number'
          type='text'
          value={phoneNumber}
          onChange={(e) => handleChange(setPhoneNumber, 'phoneNumber')(formatPhoneNumber(e.target.value)) }
        />
        <p className='error'>{errors.phoneNumber}</p>

        <input
          placeholder='Email address'
          type='text'
          value={email}
          onChange={handleChange(setEmail, 'email')}
        />
        <p className='error'>{errors.email}</p>

        <InputAutocompleteAddress
          onSelect={({ formatted_address }) => {
            const addressWithoutCountry = formatted_address.replace(/, [^,]*$/, "");
            const onChange = handleChange(setInvestmentAddress, 'investmentAddress');
            onChange(addressWithoutCountry);
          }}
        />
        <p className='error'>{errors.investmentAddress}</p>

        <p className='other-information'>Other information that can help our loan officers get you the best rate</p>
        <textarea placeholder='Comments' value={comments} onChange={handleChange(setComments, 'comments')} />

        <div className='loan-options-button' onClick={isLoading ? () => {} : () => handleSubmission()}>
          Contact me with loan options
        </div>
        <p className='caption'>
          We will NEVER sell your info.<br></br>
          By providing your phone and email, you agree to receive text messages from Constitution Lending.
        </p>
      </div>
    </div>
  );
}